/* unplugin-vue-components disabled */import { render } from "./FloorSVG.vue?vue&type=template&id=7f305d54"
import script from "./FloorSVG.vue?vue&type=script&lang=js"
export * from "./FloorSVG.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__